export const userMaintenanceEN = {
    "User Maintenance": "User Maintenance",
    "New User": "New User",
    "Testing Keys": "Testing Keys",
    "Change Password Canceled": "Change Password Canceled",
    "Two different passwords were entered in the password fields": "Two different passwords were entered in the password fields.",
    "Cancel": "Cancel",
    "Change Password": "Change Password",
    "The password was successfully changed": "The password was successfully changed.",
    "OK": "OK",
    "Add User Canceled": "Add User Canceled",
    "Please enter a name for the new user": "Please enter a name for the new user.",
    "Organization Name": "Organization Name",
    "Clinician ID": "Clinician ID",
    "Add ID": "Add ID",
    "Ambry Ordering Keys": "Ambry Ordering Keys",
    "Client ID": "Client ID",
    "Client Secret Key": "Client Secret Key",
    "URL": "URL",
    "Grant Type": "Grant Type",
    "Save": "Save",
    "Passwords must contain": "Passwords must contain at least one lowercase, uppercase, number and special character (e.g. @,#,$,%).",
    "Password": "Password",
    "Retype Password": "Retype Password",
    "User Name": "User Name",
    "First Name": "First Name",
    "Locked": "Locked",
    "Enable Web Client Access": "Enable Web Client Access",
    "Web Client Administrator": "Web Client Administrator",
    "Last Name": "Last Name",
    "Email": "Email",
    "Profile Format": "Profile Format",
    "Delete ID": "Delete ID",
    "Delete User": "Delete User",
    "Username": "Username",
    "Created Date": "Created Date",
    "Created By": "Created By",
    "Password Changed": "Password Changed",
    "Locked Date": "Locked Date",
    "Delete Ambry ID": "Delete Ambry ID",
    "Are you sure you want to delete this Ambry ID": "Are you sure you want to delete this Ambry ID?",
    "Are you sure you want to delete this user": "Are you sure you want to delete this user?",
    "Are you sure you want to delete all selected users?": "Are you sure you want to delete all selected users?",
    "Delete Users": "Delete Users",
    "pwNewUser": "Please enter a password for the new user.",
    "pwSamePrevious": "Please enter a new password. The password you entered is the same as your previous one.",
    "pwLengthError": "Passwords must be at least 8 characters long. Please enter a new password.",
    "pwNoUsername": "Passwords cannot contain the username. Please enter a new password.",
    "pwRequirements": "Password does not meet requirements. Please check the password.",
    "userAlready": "There is already a user named %{name} in this database.",
    "userNumber": "Usernames cannot start with a number, please try another username.",
    "userQuotes": "Usernames cannot contain single or double quotes, please try another username.",
    "userColons": "Usernames cannot contain colons or semicolons, please try another username.",
    "userProggrp": "PROGGRP is a reserved word, please try another username.",
    "userSTusers": "There is a problem inserting user into the st_users table.",
    "userGrant": "There is a problem giving a user GRANT permissions.",
    "userWeb": "There is a problem giving a user WEB access.",
    "Hide Settings": "Hide Settings",
    "Show Settings": "Show Settings",
    "Settings": "Settings",
    "Use class based options": "Use class based options",
    "Form Design": "Form Design",
    "Individual SS": "Individual SS",
    "Save/Delete SS Formats": "Save/Delete SS Formats",
    "Save Icon Formats": "Save Icon Formats",
    "Save Pedigree Properties": "Save Pedigree Properties",
    "Enforce Data Entry Validations": "Enforce Data Entry Validations",
    "Fields": "Fields",
    "Pedigrees": "Pedigrees",
    "Individuals": "Individuals",
    "Orders": "Orders",
    "Invites": "Invites",
    "Invites Admin": "Invites Admin",
    "Test Results": "Test Results",
    "Are you sure you want to delete the selected class?": "Are you sure you want to delete the selected class?",
    "Confirm Delete Class": "Confirm Delete Class",
    "classNameEmptyError": "Class Name is empty. Please enter a new user class",
    "Add Class": "Add Class",
    "Edit Class": "Edit Class",
    "Class Name": "Class Name",
    "Delete Class": "Delete Class",
    "Edit User Class": "Edit User Class",
    "Add": "Add",
    "clientInterfaceDescription": "Ability to create patients, build and run spreadsheets, and send and review FHQ invites",
    "Individual Datasheet": "Individual Datasheet",
    "Pedigree Datasheet": "Pedigree Datasheet",
    "Show Spreadsheet": "Show Spreadsheet",
    "Subtext Format": "Subtext Format",
    "Symbol Format": "Symbol Format",
    "Pedigree Fields": "Pedigree Fields",
    "Load Format": "Load Format",
    "Format Name": "Format Name",
    "Load": "Load",
    "Delete Format": "Delete Format",
    "Administrator": "Administrator",
    "End User Administrator": "End User Administrator",
    "Profile Management": "Profile Management",
    "New User Profile Format": "New User Profile Format",
    "Profile Formats": "Profile Formats",
    "Add Format": "Add Format",
    "Profile Name": "Profile Name",
    "Delete Profile Format": "Delete Profile Format",
    "Are you sure you want to delete all selected profile formats?": "Are you sure you want to delete all selected profile formats?",
    "Add Profile Cancelled": "Add Profile Cancelled",
    "There is already a profile format with that name": "There is already a profile format with that name",
    "New Spreadsheet": "New Spreadsheet",
    'The maximum name length is': 'The maximum name length is',
    'Please enter a valid email': 'Please enter a valid email',
    'Security': 'Security',
    'Licensing': 'Licensing',
    'Formats': 'Formats',
    'Ambry IDs': 'Ambry IDs',
    'Manage': 'Manage',
    "reservedWord": "is a reserved word, please try another username.",
    'An error occurred while creating the profile': 'An error occurred while creating the profile',
    'An error occurred while saving data': 'An error occurred while saving data',
    'Username cannot contain special characters except underscore (_) or dash (-)':'Username cannot contain special characters except underscore (_) or dash (-)',
    "Class Name cannot contain any special characters except underscore (_), dash (-) or space ( )": "Class Name cannot contain any special characters except underscore (_), dash (-) or space ( )",
    'Format Name cannot contain any special characters except underscore (_), dash (-) or space ( )':'Format Name cannot contain any special characters except underscore (_), dash (-) or space ( )'
};